import { Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StarIcon from "@mui/icons-material/Star";
import { formatWeightWithUnits } from "../../../utils";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import BatchProductList from "../../ProductionChart/components/BatchProductList";
import BatchIngredientList from "../../ProductionChart/components/BatchIngredientList";

export const Batches = (props) => {
  const { selectedOption, templates, globalData } = props;
  const batchRef = useRef(null);
  useEffect(() => {
    if (batchRef.current) {
      batchRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [templates.indexColumn]); // Scroll when a new batch is selected
  const IngredientItem = ({ item, level = 0 }) => {
    const [expanded, setExpanded] = useState(false);
    const hasSubItems = item.type === "recipe";
    const isMainIngredient =
      item?.pivot?.is_main_ingredient === 1 ? true : false; // Assuming this flag exists in your data

    const handleExpand = () => {
      setExpanded(!expanded);
    };

    return (
      <Box
        sx={{
          backgroundColor: level === 0 ? "#F8FAFC" : "transparent",
          borderRadius: level === 0 ? "6px" : "none",
          padding: level === 0 ? "8px 12px" : "6px 16px",
          marginY: level === 0 ? "4px" : "0px",
          border: level === 0 ? "1px solid #E0E0E0" : "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: `${level * 20}px`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: level === 0 ? 600 : 400 }}
              width={"200px"}
            >
              {item?.ingredient_name
                ? item?.ingredient_name
                : item?.recipe_name}
            </Typography>
            {hasSubItems && (
              <IconButton size="small" onClick={handleExpand}>
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                  }}
                />
              </IconButton>
            )}
            {isMainIngredient ? (
              <StarIcon sx={{ color: "#1760D2", fontSize: 18 }} /> // Star icon for main ingredients
            ) : null}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography fontWeight={600} fontSize={"14px"}>
              {formatWeightWithUnits(
                item.pivot.base_unit_qty,
                item.pivot.base_unit_symbol,
                globalData?.all_Units
              )}
            </Typography>
          </Box>
        </Box>

        {hasSubItems && expanded && (
          <Box>
            {item.ingredient.map((subItem, index) => (
              <IngredientItem key={index} item={subItem} level={level + 1} />
            ))}
          </Box>
        )}
      </Box>
    );
  };
  const currentBatch = templates?.templateBatchItems;

  return selectedOption?.ingredients?.length ? (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        height: "calc(90vh - 128px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "345px",
          px: "12px",
          gap: "12px",
          pb: "12px",
          borderRight: { sm: 1 },
          borderColor: { sm: "divider" },
          overflowY: "auto",
          height: "calc(90vh - 128px)",
        }}
      >
        <Box
          pt="16px"
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "background.paper",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
            }}
          >
            Batch is for
          </Typography>
        </Box>
        <BatchProductList
          products={selectedOption?.products}
          globalData={globalData}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flex: 2,
          pb: "12px",
          overflowY: "auto",
          maxHeight: "calc(90vh - 128px)",
          px: "12px",
        }}
      >
        <Box
          pt="16px"
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "background.paper",
            zIndex: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
            }}
          >
            Ingredients
          </Typography>
        </Box>

        <BatchIngredientList
          currentBatch={currentBatch}
          selectedStore={selectedOption}
          batchIndex={templates.indexColumn}
          type="preview"
          globalData={globalData}
        />
      </Box>
    </Stack>
  ) : (
    <Stack
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="555px"
    >
      <img src={emptyIcon} alt="empty" />
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          color: "#485364",
        }}
      >
        There are no products or ingredients yet!. You need to create batch
        first.
      </Typography>
    </Stack>
  );
};
